/* eslint-disable no-useless-escape */
import { /* IconButton, */ useMediaQuery } from "@mui/material";
import React, { useRef } from "react";
import ImageGallery from "react-image-gallery";
//import blueArrow from "../../assets/blue-arrow.svg";
type Props = {
  images: any;
};

const ProductImageGallery: React.FC<Props> = (props) => {
  const isLargeScreen = useMediaQuery("(min-width: 1200px)");
  const galleryRef = useRef(null);

  const cleanURL = (url: string) => url.replace(/[\[\]']+/g, "");

  const formattedImages = props.images.map((url: string) => ({
    original: cleanURL(url),
    thumbnail: cleanURL(url),
    /* originalHeight: "84px",
    originalWidth: "66px",
    thumbnailHeight: "21px",
    thumbnailWidth: "21px", */
  }));

  /* 
  const PreviousArrow: React.FC = (props) => (
    <div {...props} className="custom-prev-arrow">
      <IconButton
        disableRipple
        aria-label="previous slidder "
        sx={{
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <img
          id="previous-icon"
          alt="previous icon"
          src={blueArrow}
          style={{ transform: "rotate(180deg)", width: "10px", height: "10px" }}
        />
      </IconButton>
    </div>
  );

  const NextArrow: React.FC = (props) => (
    <div {...props} className="custom-next-arrow">
      <IconButton
        disableRipple
        aria-label="next slider"
        sx={{
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <img
          id="next-icon"
          alt="next icon"
          src={blueArrow}
          style={{ width: "10px", height: "10px" }}
        />
      </IconButton>
    </div>
  );

  const scrollThumbnails = (direction: string) => {
    const gallery = galleryRef.current as unknown as HTMLElement;
    if (gallery) {
      const thumbnails = gallery?.querySelector(
        ".image-gallery-thumbnails-container"
      );
      if (thumbnails) {
        const scrollAmount = direction === "prev" ? -165 : 165;
        thumbnails.scrollBy({
          top: 90,
          left: scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };

  const renderCustomControls = () => {
    return (
      <div>
        <button onClick={() => scrollThumbnails("prev")}>
          <PreviousArrow />
        </button>
        <button onClick={() => scrollThumbnails("next")}>
          <NextArrow />
        </button>
      </div>
    );
  }; */

  return (
    <div>
      <style>
        {`
          .image-gallery-slide img {
            max-width: ${isLargeScreen ? "800px" : "100%"};
            max-height: ${isLargeScreen ? "600px" : "100%"};
            margin: auto;   
            height: 400px; /* Fixed height for original images */
          }
          .image-gallery-thumbnails-container img {
            height: 100px; /* Fixed height for thumbnail images */
          }
          .image-gallery-thumbnails-container {
            position: relative;
          }

          .custom-prev-arrow,
          .custom-next-arrow {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 999;
          }

          .custom-prev-arrow {
            left: 0;
          }

          .custom-next-arrow {
            right: 0;
          }

          .custom-arrow-button {
            background-color: transparent;
            border: none;
            cursor: pointer;
            padding: 0;
          }
        `}
      </style>
      <ImageGallery
        ref={galleryRef}
        items={formattedImages}
        autoPlay={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showNav={false}
        disableThumbnailScroll={true}
        //  renderCustomControls={renderCustomControls}
      />
    </div>
  );
};

export default ProductImageGallery;
